import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import ShortLinkDropdown from '../../../components/DropDown/ShortLinkDropdown';
import _debounce from 'lodash/debounce';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { useNavigate } from 'react-router-dom';

const ImportPage = ({ callback }) => {
    const [show, setShow] = useState(false);
    const [customBackResp, setCustomBackResp] = useState(null);
    const [platform, setPlatform] = useState(null);

    const navigate = useNavigate();

    const handleClose = () => {
        setCustomBackResp(null);
        setPlatform(null);
        setShow(false);
    };

    const handleShow = () => {
        setShow(true)
    };

    const checkCustomBackHalf = async (e) => {
        let postData = {
            "linkCode": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkCustomBackHalf);
            setCustomBackResp(resp);
        } else if (e.target.value?.length == 0) {
            setCustomBackResp(null);
        }
    }

    async function submit() {
        if (!document.getElementById("external-url").value?.trim()) {
            toast.error('Please enter external URL');
            return;
        }
        if (platform === null) {
            toast.error('Please select platform');
            return;
        }
        loadingShow();
        let postData = {
            "url": document.getElementById("external-url").value?.trim(),
            "linkCode": document.getElementById('linkCode').value?.trim(),
        }
        let resp = await postApi(postData, urlApi.importPage + platform);
        loadingHide();
        if (resp.responseCode === 200) {
            // navigate('/create-page/' + resp?.data);
            if (callback) {
                callback();
            }
            handleClose();
        } else {
            toast.error(resp.message);
        }

    }

    return (
        <>
            <button className='primary-btn' onClick={handleShow}>Import Page</button>
            <Modal show={show} onHide={handleClose} size='lg' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Import Page</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <p className="text-sm text-center text-[var(--secondary-text)] mb-3">Import Your Old Design from <b>'bit.ly'</b> & others platforms. <br /> Attriva powers hundreds of thousands of pages for creators and businesses of all kinds. </p>

                    <p className="text-[15px] font-semibold mb-1">Your External URL</p>
                    <div className="flex flex-wrap md:flex-nowrap">
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <select name="" id="select-short-link-domain" className='form-control w-full' onChange={(e) => setPlatform(e.target.value)}>
                                <option value={null} disabled selected>--Select platform--</option>
                                <option value={'bitly'}>Bit.ly</option>
                            </select>
                        </div>
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <input type='text' id='external-url' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder={`Your ${platform || ''} Page URL`} />
                            {/* <p className="mb-0 text-xs text-gray-500">
                                *Minimum 3 characters, including alphanumeric and special (only ' - ' , ' _ ') characters.
                            </p> */}
                        </div>
                    </div>

                    <p className="text-sm text-center text-yellow-600 mb-3">*After Submitting please re-check, it can take some time depend upon server speed  , <br />if the page not showing in the list please refresh the page and publish your page. </p>

                    <p className="text-[15px] font-semibold mb-1">Claim your URL</p>
                    <div className="flex flex-wrap md:flex-nowrap">
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <ShortLinkDropdown isTitle={false} />
                        </div>
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <input type='text' id='linkCode' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Your name / Business (Minimum 3 Character)' onChange={_debounce((e) => checkCustomBackHalf(e), 300)} />
                            <p className="mb-0 text-xs text-gray-500">
                                *Minimum 3 characters, including alphanumeric and special (only ' - ' , ' _ ') characters.
                            </p>
                            {
                                customBackResp &&
                                <div className={`text-xs ps-1 ${customBackResp?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{customBackResp?.message}</div>
                            }
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-between gap-3'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ImportPage